import { OrangeButton } from "@/components/Buttons"
import { handleDownloadDocuments } from "../Utils/handleDownloadDocuments"
import { FaDownload } from "react-icons/fa"

export function DownloadDocumentsButton({ project_id }: { project_id: string }) {
    const handleOnClick = () => {
        handleDownloadDocuments(project_id)
    }
    return (
        <OrangeButton onClick={handleOnClick}>
            <div className="flex flex-row gap-2 items-center">
                <FaDownload />
                Download Documents
            </div>
        </OrangeButton>
    )
}